import { type ReactNode, useEffect } from 'react';

import { useEchoNavigate } from '../hooks/useEchoNavigate';

import type { EchoNavigation } from '../types';

export function EchoNavigate({ echo, fallback }: { echo: EchoNavigation; fallback: ReactNode }) {
  const echoNavigate = useEchoNavigate();

  useEffect(() => {
    void echoNavigate(echo);
  }, [echo, echoNavigate]);

  return fallback;
}
